import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { LiaPhoneSolid } from "react-icons/lia";
import { useState } from 'react';
import ReportDescriptionModal from './ReportDescriptionModal';

const ReenrollmentPhoneCallChart = ({report}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Custom tooltip for the line chart
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="text-gray-900 font-medium">{data.formattedDate}</p>
          <p className="text-green-600 font-semibold">
            {data.value} ligações
          </p>
        </div>
      );
    }
    return null;
  };

  // Format date for display
  const formatDate = (dateString) => {
    // Parse the date string directly to avoid timezone issues
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}`;
  };

  // Transform the report data for the chart
  const data = report?.lines?.map(line => ({
    date: line.key,
    formattedDate: formatDate(line.key),
    value: parseInt(line.value),
    order: line.order
  })).sort((a, b) => a.order - b.order) || [];

  const totalCalls = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <>
      <div className='flex items-center gap-2 mb-4'>
        <LiaPhoneSolid className="text-xl text-blue-600" />
        <h3 className='text-lg font-semibold text-gray-900'>{report?.title || 'Ligações de Rematrícula'}</h3>
        {report?.description && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-500 transition-colors duration-200"
          >
            <span className="text-white text-xs font-bold">?</span>
          </button>
        )}
      </div>
      
      {/* Line Chart */}
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{
              top: 10,
              right: 20,
              left: 10,
              bottom: 10,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis 
              dataKey="formattedDate" 
              tick={{ fontSize: 11, fill: '#6B7280' }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <YAxis 
              tick={{ fontSize: 11, fill: '#6B7280' }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line 
              type="monotone" 
              dataKey="value" 
              stroke="#10B981" 
              strokeWidth={3}
              dot={{ fill: '#10B981', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: '#10B981', strokeWidth: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Summary Stats */}
      <div className="mt-6 px-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Total de Ligações</p>
            <p className="text-xl font-semibold text-gray-900">{totalCalls.toLocaleString()}</p>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-600">Período</p>
            <p className="text-sm text-gray-700">Últimos 7 dias</p>
          </div>
        </div>
      </div>
      
      <ReportDescriptionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={report?.title || 'Ligações de Rematrícula'}
        description={report?.description}
      />
    </>
  );
};

export default ReenrollmentPhoneCallChart;
